"use strict";
import Navbar from "components/NavBar/index";
import { DeprecationBanner } from "components/TopLevelBanners/DeprecationBanner";
import { PageType, useIsPage } from "hooks/useIsPage";
import { useScroll } from "hooks/useScroll";
import { GRID_AREAS } from "pages/App/utils/shared";
import { memo, useMemo } from "react";
import { Flex } from "ui/src";
import { zIndexes } from "ui/src/theme";
export const Header = memo(function Header2() {
  const isLandingPage = useIsPage(PageType.LANDING);
  const { isScrolledDown } = useScroll({ enabled: !isLandingPage });
  const isHeaderTransparent = useMemo(() => {
    if (isLandingPage) {
      return true;
    }
    return !isScrolledDown;
  }, [isLandingPage, isScrolledDown]);
  return <Flex
    id="AppHeader"
    $platform-web={{
      gridArea: GRID_AREAS.HEADER,
      position: "sticky"
    }}
    className="webkitSticky"
    width="100vw"
    top={0}
    zIndex={zIndexes.dropdown}
    pointerEvents="none"
  >
      <style>
        {`
          .webkitSticky {
            position: -webkit-sticky;
          }
        `}
      </style>
      <Flex position="relative" zIndex={zIndexes.sticky} pointerEvents="auto">
        <DeprecationBanner />
      </Flex>
      <Flex
    width="100%"
    backgroundColor={isHeaderTransparent ? "transparent" : "$surface1"}
    borderBottomColor={isHeaderTransparent ? "transparent" : "$surface3"}
    borderBottomWidth={1}
    pointerEvents="auto"
  >
        <Navbar />
      </Flex>
    </Flex>;
});
